export default class Predict {
  constructor() {
    this.value = 0;
    this.checked = false;
  }
}
